module.exports = __webpack_public_path__ + "img/Travel_Recall_3_Set.bfd7a360.png";